import React, { FC, useEffect } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { useUnionStatusGroup } from '@blocs.filter';
import { FiltersNameEnum } from '../../../shared/types';
import { FormItem } from '../../../shared/styles';
import { FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';
import { UnionStatus } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const UnionStatusCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);
  const unionStatusGroup = useUnionStatusGroup();

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.unionStatus
  );

  useEffect(() => {
    assignOptionsToCategoryFilters({
      [FiltersNameEnum.unionStatus]: unionStatusGroup,
    });
  }, []);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <UnionStatus label={filtersLabelOfAudience[FiltersNameEnum.unionStatus]} />
      </FormItem>
    )
  );
};

export default UnionStatusCategory;
